import Vue from 'vue';
import { colorConstant } from '../common/styles/colors.constant';
import 'vuetify/src/stylus/app.styl';
import Vuetify from 'vuetify/es5/components/Vuetify';
import VApp from 'vuetify/es5/components/VApp';
import VNavigationDrawer from 'vuetify/es5/components/VNavigationDrawer';
import VFooter from 'vuetify/es5/components/VFooter';
import VList from 'vuetify/es5/components/VList';
import VBtn from 'vuetify/es5/components/VBtn';
import VBtnToggle from 'vuetify/es5/components/VBtnToggle';
import VIcon from 'vuetify/es5/components/VIcon';
import VGrid from 'vuetify/es5/components/VGrid';
import VToolbar from 'vuetify/es5/components/VToolbar';
import VCard from 'vuetify/es5/components/VCard';
import VTextField from 'vuetify/es5/components/VTextField';
import VForm from 'vuetify/es5/components/VForm';
import VProgressLinear from 'vuetify/es5/components/VProgressLinear';
import VSubheader from 'vuetify/es5/components/VSubheader';
import VDivider from 'vuetify/es5/components/VDivider';
import VCheckbox from 'vuetify/es5/components/VCheckbox';
import VRadioGroup from 'vuetify/es5/components/VRadioGroup';
import transitions from 'vuetify/es5/components/transitions';
import VTooltip from 'vuetify/es5/components/VTooltip';
import VTextarea from 'vuetify/es5/components/VTextarea';
import VImg from 'vuetify/es5/components/VImg';
import VDialog from 'vuetify/es5/components/VDialog';
import VAvatar from 'vuetify/es5/components/VAvatar';
import VSwitch from 'vuetify/es5/components/VSwitch';
import VMenu from 'vuetify/es5/components/VMenu';
import VLabel from 'vuetify/es5/components/VLabel';
import VDatePicker from 'vuetify/es5/components/VDatePicker';
import VExpansionPanel from 'vuetify/es5/components/VExpansionPanel';
import VBreadcrumbs from 'vuetify/es5/components/VBreadcrumbs';
import VProgressCircular from 'vuetify/es5/components/VProgressCircular';
import VTabs from 'vuetify/es5/components/VTabs';
import VSelect from 'vuetify/es5/components/VSelect';
import VCarousel from 'vuetify/es5/components/VCarousel';
import VStepper from 'vuetify/es5/components/VStepper';
import VAutocomplete from 'vuetify/es5/components/VAutocomplete';
import VChip from 'vuetify/es5/components/VChip';
import VRangeSlider from 'vuetify/es5/components/VRangeSlider';
import VDataTable from 'vuetify/es5/components/VDataTable';
import VRating from 'vuetify/es5/components/VRating';
import VPagination from 'vuetify/es5/components/VPagination';
import VCombobox from 'vuetify/es5/components/VCombobox';
import VAlert from 'vuetify/es5/components/VAlert';
import VSpeedDial from 'vuetify/es5/components/VSpeedDial';
import VSnackbar from 'vuetify/es5/components/VSnackbar';

Vue.use(Vuetify, {
    components: {
        VApp,
        VNavigationDrawer,
        VFooter,
        VList,
        VBtn,
        VBtnToggle,
        VIcon,
        VGrid,
        VToolbar,
        VCard,
        VTextField,
        VTextarea,
        VForm,
        VProgressLinear,
        VSubheader,
        VDivider,
        VCheckbox,
        VRadioGroup,
        transitions,
        VTooltip,
        VImg,
        VDialog,
        VAvatar,
        VSwitch,
        VMenu,
        VLabel,
        VDatePicker,
        VExpansionPanel,
        VBreadcrumbs,
        VProgressCircular,
        VTabs,
        VSelect,
        VCarousel,
        VStepper,
        VAutocomplete,
        VChip,
        VRangeSlider,
        VDataTable,
        VRating,
        VPagination,
        VCombobox,
        VAlert,
        VSpeedDial,
        VSnackbar,
    },
    theme: {
        //TODO: configure
        ...colorConstant(),
        primary: '#083050',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
    },
    breakpoint: {
        thresholds: {
            xs: 767,
            sm: 1023,
            md: 1199,
            lg: 1300,
            xl: 1600,
        },
    },
});
